import EA from 'helpers/init';

export default EA.Methods.socialShare = ($this) => {
    const url   = encodeURIComponent(window.location.href);
    const title = encodeURIComponent(document.title);
    const btns  = $this.querySelectorAll('.social-btn');

    const shareUrls = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${url}`,
        twitter: `https://twitter.com/intent/tweet?url=${url}&text=${title}`,
    };

    const openPopup = (href) => {
        window.open(href, '_blank', 'width=620,height=440,noopener,noreferrer');
    };

    btns.forEach(btn => {
        const rel = btn.getAttribute('rel') || '';

        const network = ['facebook', 'linkedin', 'twitter'].find(n => rel.includes(n));

        if (network) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                openPopup(shareUrls[network]);
            });

        } else if (rel.includes('email')) {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                window.location.href = `mailto:?subject=${title}&body=${url}`;
            });

        } else if (rel.includes('share')) {
            btn.addEventListener('click', async (e) => {
                e.preventDefault();

                if (navigator.share) {
                    try {
                        await navigator.share({ title: document.title, url: window.location.href });
                    } catch (_) {
                        //cancelled
                    }
                    return;
                }

                try {
                    await navigator.clipboard.writeText(window.location.href);
                } catch (_) {
                    //cancelled
                }
            });
        }
    });
};
